import * as React from 'react'
import { apiCallWrapperNoDispatch, Col, Grid, IdNameModel, Row, Select, SelectFormField, SelectOptionModel } from 'traveldesk-ui'
import { Buttons } from 'traveldesk-ui'
interface Props {
    onCitySelected: (cityId: number, cityName: string) => void
    countriesOptions?: SelectOptionModel[]
}

const CitySelector: React.FC<Props> = (props: Props) => {
    const [selectedCountryId, setSelectedCountryId] = React.useState<number>(0)
    const [selectedCityId, setSelectedCityId] = React.useState<number>(0)
    const [countriesOptions, setCountriesOptions] = React.useState<SelectOptionModel[]>([])
    const [citiesOptions, setCitiesOptions] = React.useState<SelectOptionModel[]>([])
    const requestCountriesOptions = async () => {
        const response = await apiCallWrapperNoDispatch<SelectOptionModel[]>(`/api/countries/options`)
        if(response.IsOk){
            setCountriesOptions(response.Content || [])
        }
        else {
            alert(response.ErrorMessage)
        }        
    }
    const requestCitiesOptions = async () => {
        if(selectedCountryId){
            const response = await apiCallWrapperNoDispatch<IdNameModel[]>(`/api/cities/incountries?countriesIds=${selectedCountryId}`)
            if(response.IsOk){
                setCitiesOptions(response.Content?.map(city => ({value: city.id, label: city.name})) || [])
            }
            else {
                alert(response.ErrorMessage)
            }
        } else {
            setCitiesOptions([])
        }
    }
    React.useEffect(() => {
        requestCitiesOptions()
    },[selectedCountryId])
    React.useEffect(() => {
        if(props.countriesOptions){
            setCountriesOptions(props.countriesOptions)
        } else {
            requestCountriesOptions()
        }
    },[props.countriesOptions])
    return (
        <>
            <Row>
                <Col type="50">
                    <SelectFormField
                        options={countriesOptions}
                        value={selectedCountryId}
                        onChange={(e: SelectOptionModel) => setSelectedCountryId(e.value as number)}
                    />
                </Col>           
                <Col type="50">
                    <SelectFormField
                        options={citiesOptions}
                        value={selectedCityId}
                        onChange={(e: SelectOptionModel) => setSelectedCityId(e.value as number)}
                    />
                </Col>
            </Row>
            <Row>
                <Col type="100">
                    <Buttons.ButtonSmallGreen
                        onClick={() => props.onCitySelected(
                            selectedCityId,
                            citiesOptions.find(city => city.value === selectedCityId)?.label ?? '',
                        )}
                    >
                        Save mapping
                    </Buttons.ButtonSmallGreen>
                </Col>
            </Row>
        </>
    )
}
export default CitySelector